import React, { Fragment, useCallback } from 'react';   

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { RaisedButton, Dialog } from 'material-ui';

import { changePort } from 'actions/regions/ports';
import { formValueSelector, reduxForm } from 'redux-form';

import { formName } from 'data/formNames';

import ServiceProviderFormFields from './FormFields';

const styles = {
    dialog: {
        contentStyle: { width: '843px', padding: '20px' },
    },
    textField: {
        floatingLabelStyle: {
            fontSize: '12px',
        },
    },
    btn: {
        labelStyle: { color: '#fff' },
    },
};

function AddServiceProvider(props) {
    const {
        open, field, toggle, serviceProvider, fields, handleSubmit, changePort, 
        change: formChange, hasRecommended,
    } = props;

    const onRequestClose = useCallback(() => {
        fields.pop();
        toggle();
    }, [fields, toggle]);

    const onSubmit = (submit) => {
        toggle();
        changePort(submit);
    };

    return (
        <Dialog
            open={open}
            contentStyle={styles.dialog.contentStyle}
            onRequestClose={onRequestClose}
            paperClassName="dialog-service-provider"
            bodyStyle={{ overflowY: 'auto' }}
        >
            <Fragment>
                <form>
                    <div className="title">
                        Add Service Provider: <br />
                        Marine equipment & spare parts
                    </div>

                    <ServiceProviderFormFields 
                        field={field}
                        serviceProvider={serviceProvider}
                        formChange={formChange}
                        hasRecommended={hasRecommended}
                    />

                    <div className="row">
                        <div className="col-xs-12" style={{ display: 'flex', gap: '10px' }}>
                            <RaisedButton
                                label="Cancel"
                                primary
                                onClick={onRequestClose}
                            />

                            <RaisedButton
                                label="Add"
                                backgroundColor="#7FC931"
                                labelStyle={styles.btn.labelStyle}
                                onClick={handleSubmit(onSubmit)}
                            />
                        </div>
                    </div>
                </form>
            </Fragment>
        </Dialog>
    );
}

AddServiceProvider.propTypes = {};

AddServiceProvider.defaultProps = {};

const FormAddServiceProvider = reduxForm({
    form: formName.portUpdateAddServiceProvider,
    enableReinitialize: true,
})(AddServiceProvider);

const selector = formValueSelector(formName.portUpdate);
const selectorAddServiceProvider = formValueSelector(formName.portUpdateAddServiceProvider);
export default connect(
    (state, ownProps) => ({
        initialValues: { serviceProviders: selector(state, 'serviceProviders') },
        serviceProvider: selectorAddServiceProvider(state, ownProps.field),
    }),
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(FormAddServiceProvider);



// WEBPACK FOOTER //
// ./app/components/Regions/Port/ServiceProviders/AddServiceProvider.jsx